<template>
  <ul class="pl-chat-list">
    <div v-if="!messages.length && chatType === 'public'" class="pl-chat-list__message-empty">
      Пока никто не написал ни одного сообщения. Стань первым.
    </div>

    <div v-if="!messages.length && activeChatId !== -1 && chatType === 'private'" class="pl-chat-list__message-empty">
      В этом приватном чате пока нет сообщений.
    </div>

    <div
      v-if="activeChatId === -1 && chatType === 'private' && idSelectedUser !== null"
      class="pl-chat-list__message-empty"
    >
      У вас пока нет чата с этим коллегой. Напишите сообщение, чтобы создать приватный чат.
    </div>

    <li
      v-for="message in messages"
      :key="`${message.id}_${message.message}`"
      :ref="`message_${message.id}`"
      :class="{ 'pl-chat-list__item--target': isItTargetMessage(message.id) }"
      class="pl-chat-list__item"
      @click="addOrRemoveFromSelectedMessages(message)"
    >
      <pl-chat-message
        :message="message"
        :userProfile="userProfile"
        :members="members"
        :is-selected="isMessageInSelected(message.id)"
        @newTargetMessage="goToMessage($event)"
        @forwardEventByMessage="$emit('forwardEventFromList')"
      />
    </li>

    <div v-if="endOfStory()" class="pl-chat-list__loader">
      <preloader v-show="messageLoading" :size="50" />
    </div>

    <div v-if="!endOfStory() && messages.length" class="pl-chat-list__message-end-story">
      Конец истории. Сообщений больше нет.
    </div>
  </ul>
</template>

<script>
import PlChatMessage from './PlChatMessage'
import debounce from './debounce'

export default {
  name: 'PlChatMessageList',
  components: {
    PlChatMessage,
  },
  data() {
    return {
      messageLoading: false,
      targetMessageIdForScroll: null,
      targetTimeout: null,
    }
  },
  props: {
    isOpenSearch: {
      type: Boolean,
      default: false,
    },
    activeChatId: {
      type: Number || null,
      default: null,
    },
    idSelectedUser: {
      type: Number || null,
      default: null,
    },
    chatType: {
      type: String,
      default: '',
    },
    messages: {
      type: Array,
      default: () => [],
    },
    targetMessageDataFromChatList: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    const messageList = document.querySelector('.pl-chat-list')
    messageList.addEventListener('scroll', this.listenScroll)

    if (this.targetMessageDataFromChatList.refKey) {
      this.goToMessageFromChatList(this.targetMessageDataFromChatList)
    }
  },
  computed: {
    userProfile() {
      return this.$store.state.plChat.profile
    },
    members() {
      const chat = this.$store.getters.chatById(this.activeChatId)

      if (chat) {
        return chat.users
      }

      return []
    },
  },
  methods: {
    addOrRemoveFromSelectedMessages(message) {
      if (message.isSystem) {
        return
      }

      if (this.isMessageInSelected(message.id)) {
        this.$store.commit('removeMessageFromSelected', message.id)
      } else {
        this.$store.commit('addMessageToSelected', message)
      }
    },
    isMessageInSelected(messageId) {
      return this.$store.getters['selectedMessages'].some(item => item.id === messageId)
    },
    isItTargetMessage(messageId) {
      return messageId === this.targetMessageIdForScroll
    },
    goToMessageFromChatList(messageData) {
      const goToMessageCallback = () => {
        if (this.$refs[messageData.refKey]) {
          this.goToMessage(messageData)
        } else {
          setTimeout(() => {
            goToMessageCallback()
          }, 100)
        }
      }

      goToMessageCallback()
    },
    goToMessage({ messageId, refKey }) {
      // скроллим и выделяем сообщение, если оно из текущего чата
      if (this.$refs[refKey]) {
        const elem = this.$refs[refKey][0]

        this.targetMessageIdForScroll = messageId
        elem.scrollIntoView({ block: 'center', behavior: 'smooth' })

        // очищаем предыдущий таймаут и далее ставим новый
        if (this.targetTimeout) {
          clearTimeout(this.targetTimeout)
        }

        this.targetTimeout = setTimeout(() => {
          this.targetMessageIdForScroll = null
          this.targetTimeout = null
        }, 3000)
      }
    },
    listenScroll() {
      const messageList = document.querySelector('.pl-chat-list')
      const messageListTop = messageList.getBoundingClientRect().top
      const lastMessage = messageList.querySelectorAll('.pl-chat-list__item')
      const lastMessageBottom = lastMessage[lastMessage.length - 1].getBoundingClientRect().bottom

      if (lastMessageBottom > messageListTop && !!this.endOfStory()) {
        this.messageLoading = true
        this.handlerLoadMessages()
      }
    },
    handlerLoadMessages: debounce(
      function () {
        this.loadMessages(null)
      },
      1000,
      false,
    ),

    //todo возникает рекеурсия при загрузке новых сообщений.
    //todo не видно спинера.
    async loadMessages() {
      await this.$store.dispatch('getMessagesChats', {
        chatIds: [this.activeChatId],
        nextPage: this.endOfStory(),
      })
      this.messageLoading = false
    },
    endOfStory() {
      const chat = this.$store.state.plChat.chatList.find(chat => chat.id === this.activeChatId)

      return chat?.nextMessagePage
    },
  },
  watch: {
    activeChatId() {
      this.$store.commit('clearSelectedMessages')
      this.$store.commit('setChatIdForForward', null)
    },
    targetMessageDataFromChatList(messageData) {
      this.goToMessageFromChatList(messageData)
    },
  },
}
</script>

<style lang="scss">
.pl-chat-list {
  list-style-type: none;
  padding: 0.5rem 0;
  flex: 1 0 100%;
  overflow-y: scroll;
  align-self: flex-end;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;

  &__item {
    padding: 0 1.5rem;
    &--target {
      background-color: rgba(0, 174, 184, 0.2);

      .pl-chat-list__message-body {
        &::before,
        &::after {
          display: none;
        }
      }
      /*box-shadow: 0 0 10px 1px rgba(0,174,184,0.5);*/
    }
  }

  &__message-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 1rem;
  }

  &__message-end-story {
    display: flex;
    justify-content: center;
    align-items: baseline;
    height: 100%;
    padding: 1rem;
  }

  &__loader {
    min-height: 100px;
    padding: 1rem;
  }
}
</style>
